import React from 'react';
import { Case } from '../types';

interface HeaderProps {
  currentCaseId: string;
  cases: Case[];
  onCaseChange: (caseId: string) => void;
}

const Header: React.FC<HeaderProps> = ({ currentCaseId, cases, onCaseChange }) => {
  return (
    <div style={{ height: 50, background: '#282c34', display: 'flex', alignItems: 'center', padding: 5 }}>
      <img src="/factrixlogo.png" alt="logo" style={{ height: 40, marginRight: 15 }} />
      <h1 style={{ color: 'white', fontSize: 20, margin: 0 }}>Singapore Crime Scene Management</h1>
      <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 10 }}>
        <label style={{ color: 'white', fontSize: 12 }}>Case:</label>
        <select
          value={currentCaseId}
          onChange={(e) => onCaseChange(e.target.value)}
          style={{
            padding: '4px 8px',
            fontSize: 12,
            borderRadius: 4,
            border: 'none',
            backgroundColor: 'white'
          }}
        >
          {cases.map(caseItem => (
            <option key={caseItem.id} value={caseItem.id}>
              {caseItem.caseNumber} - {caseItem.title}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default Header;

